module.exports = __webpack_public_path__ + "static/img/banner.ef7703f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/banner.png
// module id = XkRf
// module chunks = 0